<template>
  <div class="main-wrapper">
    <!-- <layout-header></layout-header> -->

    <!-- Page Content -->
    <div class="content bg-white">
      <div class="container">
        <router-link to="/">
          <img :src="config.base_url_for_Image + main_data" class="img-fluid" alt="Login Banner" style="height: 50px;" />
        </router-link>

        <div class="row">
          <div class="col-md-10 offset-md-1">
            <!-- Register Content -->
            <div class="account-content">
              <div style="display: flex; flex-direction: row;">
                <div class="col-md-12 col-lg-6 ml-5 mt-5 mb-5 login-left">
                  <img :src="'https://app.bhilwarahealthcare.in' + loginPageImage" class="img-fluid" alt="Login Banner"
                    style="height: 370px; border-radius: 15px; margin-left: -48px; margin-top: 17px;" />
                </div>
                <div class="col-md-12 col-lg-5 login-right">
                  <div class="login-header">
                    <div v-if="domainFor !== 'Hospital Portal'" class="switcher mb-2">
                      I am
                      <label class="m-2">
                        <input type="radio" name="type" checked @change="onChange('patient')" />
                        <span class="checkmark"></span> Patient
                      </label>
                      <label class="m-2">
                        <input type="radio" name="type" @change="onChange('doctor')" />
                        <span class="checkmark"></span> Doctor
                      </label>
                    </div>
                    <div v-else class="patient-registration-label">
                      Patient Registration
                    </div>
                  </div>

                  <!-- Register Form -->
                  <form @submit.prevent="submit_doctor">
                    <div class="input-group form-group">
                      <input type="text" name="first_name" required class="form-control floating"
                        v-model="register_patient.first_name" placeholder="First Name"
                        oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                    </div>
                    <div class="form-group">
                      <input type="text" name="last_name" required class="form-control floating"
                        v-model="register_patient.last_name" placeholder="Last Name"
                        oninput="this.value = this.value.replace(/[^a-zA-Z]/g, '');" />
                    </div>
                    <div class="form-group" style="position: relative;">
                      <button class="btn btn-default" type="button"
                        style="position: absolute; left: 0; top: 0; border: 1px solid #ccc; border-right: none; background-color: lightgrey; height: 40px; border-radius: 4px 0 0 4px; z-index: 2;">+91</button>
                      <input type="text" required maxlength="10" minlength="10" @keypress="onlyNumber"
                        v-model="register_patient.mobile_no" class="form-control floating" placeholder="Mobile Number"
                        @keydown.enter.prevent="$refs.sendOtpButton.click()"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                        style="padding-left: 60px; padding-top: 10px; padding-bottom: 10px; border-radius: 4px; letter-spacing: 2px;" />
                    </div>
                    <div class="form-group">
                      <v-select placeholder="Select City" v-model="register_patient.city" 
                        label="city" :reduce="(option) => option.city" :options="cities" required>
                      </v-select>
                    </div>

                    <div class="form-group">
                      <label class="custom_check ml-2" style="margin-top: -10px; font-size: 12px;">
                        <input type="radio" name="aggrement" checked required />
                        <span class="checkmark"></span>I read Terms and Conditions and By
                        signing up, I agree to
                        <span>
                          <a href="javascript:void(0);" style="color: #00b3d0" @click="Open_terms()">terms</a></span>
                      </label>
                    </div>

                    <div class="text-left" style="margin-top: -20px; margin-bottom: 20px;">
                      <router-link class="forgot-link" to="/login">Already have an account?</router-link>
                    </div>
                    <button ref="sendOtpButton" class="btn btn-primary btn-block btn-lg login-btn" type="submit"
                      :disabled="isDisabled">
                      Send OTP
                    </button>
                  </form>
                  <!-- /Register Form -->
                </div>
              </div>
            </div>
            <!-- /Register Content -->
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <layout-footer></layout-footer>
  </div>
</template>

<script>
import CommonApi from "../../../services/CommonApi";
import config from "../../../services/CommonApi";
import axios from "axios";
export default {
  data() {
    return {
      config: config,
      main_data: "",
      cities: [],
      domainFor: "",
      register_success: true,
      register_error: true,
      disabled: true,
      register_patient: {
        first_name: "",
        last_name: "",
        mobile_no: "",
        city: "",
        password: "",
        loginPageImage: "",
      },
    };
  },
  watch: {
    register_patient: {
      handler() {
        this.validateForm();
      },
      deep: true,
    },
  },
  computed: {
    isDisabled() {
      // Check if all required fields are filled
      return (
        !this.register_patient.first_name ||
        !this.register_patient.last_name ||
        !this.register_patient.mobile_no ||
        !this.register_patient.city
      );
    },
  },
  mounted() {
    this.get_cities();
    this.get_practitioner_profile();
    this.fetchDomainFor();
  },
  methods: {

    onCitySelect(selectedCity) {
      this.register_patient.city = selectedCity;
    },

    async fetchDomainFor() {
      try {
        const response = await axios.get(
          "https://app.bhilwarahealthcare.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        );
        if (response.data && response.data.data && response.data.data[0]) {
          this.domainFor = response.data.data[0].domain_for;
        }
      } catch (error) {
        console.error("Error fetching domainFor:", error);
      }
    },

    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://app.bhilwarahealthcare.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].logo;
            this.loginPageImage = res.data.data[0].login_page;
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "bhilwarahealthcare.in") {
            } else if (window.location.hostname == "localhost") {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://bhilwarahealthcare.in");
            }
          }

          this.$swal.close();
        });
    },

    indexPath() {
      this.$router.push("/doctor/index");
    },

    Open_terms() {
      var pdf = "https:/app.bhilwarahealthcare.in/files/terms_condition.pdf";
      window.open(pdf);
    },

    /* Form Validation */
    validateForm() {
      if (
        this.register_patient.first_name === "" ||
        this.register_patient.last_name === "" ||
        this.register_patient.mobile_no === "" ||
        this.register_patient.city === ""
      ) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },



    //Allow User to type number only
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    onChange(user) {
      if (user === "patient") {
        this.$router.push("/patient/register");
      } else {
        this.$router.push("/doctor/register");
      }
    },
    async get_cities() {
      this.selected_city = "";
      await CommonApi.get_data("sahaj.finalapi.get_city").then((res) => {
        this.cities = res.message;
      });
    },
    async submit_doctor() {
      if (this.register_patient) {
        this.$swal({
          text: "Sending OTP...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var bodyFormData = new FormData();
        bodyFormData.append("phone", this.register_patient.mobile_no);
        CommonApi.post_data("sahaj.api.send_otp", bodyFormData, true).then(
          (res) => {
            if (res.status_code == 200) {
              this.$router.push({
                name: "enter-register-OTP",
                params: { registeration_data: this.register_patient },
              });
              this.$swal.close();
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: res.message,
                showConfirmButton: true,
              });
            }
          }
        );
      }
    },
  },
};
</script>

<style scoped>
.form-focus .focus-label {
  top: -18px;
}

.patient-registration-label {
  font-size: 18px;
  /* Customize the font size as needed */
  font-weight: bold;
  /* Customize the font weight as needed */
  margin-top: 10px;
  /* Adjust the margin as needed */
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/patient/Register.vue